import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import { getBarWidthPercent, isValidPercent } from '../utils';
import { TRANSLATION_KEY } from '../constants';
import css from '../style.css';

const GoalProgressBar = ({ value, warning = false }) => {
    const valid = isValidPercent(value);
    return (
        <div className={css.progressTrack}>
            <div
                className={classNames(css.progressBar, { [css.progressBarWarning]: warning })}
                style={{ width: `${getBarWidthPercent(value)}%` }}
            />
            <span className={classNames(css.progressLabel, { [css.progressLabelInvalid]: !valid })}>
                {valid ? value : <Translate id={`${TRANSLATION_KEY}.NO_DATA_YET`} />}
            </span>
        </div>
    );
};

GoalProgressBar.propTypes = {
    value: PropTypes.string,
    warning: PropTypes.bool,
};

export default GoalProgressBar;
